import React from 'react'
import HeroSection from './HeroSection'
import Breadcrumb from './Breadcrumb'
function Verticals() {
  return (
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Verticals"
        backgroundImage="/img/verticals.jpg"
      />

      <Breadcrumb current="Verticals" />
    </div>
  )
}

export default Verticals